import { Component, EventEmitter, Input, Output } from '@angular/core';
import { opacityInOut } from '../../animations/opacity-in-out.animation';
import { scaleInOut } from '../../animations/scale-in-out.animation';
import { HelperService } from 'src/app/core/services/helper.service';

@Component({
  selector: 'vacancy-connect',
  templateUrl: 'vacancy-connect.component.html',
  styleUrls: ['vacancy-connect.component.scss'],
  animations: [ opacityInOut, scaleInOut ]
})
export class VacancyConnectComponent {

  @Input() vacancyMatchList = []
  @Output() onSelect = new EventEmitter<any>();
  @Output() onCreate = new EventEmitter<any>();
  showVacancyList = false;
  selectedId = null;
  matchId = null;

  constructor(private helperService: HelperService) {
  }

  toggleList() {
    this.showVacancyList = !this.showVacancyList;
    this.helperService.blockScroll$.next(this.showVacancyList);
  }

  connectToVacancy() {
    if (this.selectedId) {
      this.onSelect.emit(this.selectedId);
    }
    this.toggleList();
  }

  onChange(e) {
    this.selectedId = e.target.value;
  }

  selectMatch(id) {
    this.matchId = id;
  }

  createVacancy() {
    this.onCreate.emit();
  }

}
